import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import {
  Card,
  Grid,
  Tab,
  Tabs,
} from '@material-ui/core';
import { BackdropCircular, Breadcrumb } from 'components';
import {
  getQuoteProProductsBySearchCriteriaApi,
  getQuoteProProductsApi,
  getQuoteProGroupsAttributeApi,
} from 'api';
import { getAutoQuotesApi } from 'api/automatedQuotes';
import { useStyles } from 'pages/quotes/styles';
import AutomatedQuotesListings from './AutomatedQuotesListings';
import AutomatedQuotesPackages from './AutomatedQuotesPackages';


const TabPanel = ({ value, index, children }) => {
  return <div hidden={value !== index}>{children}</div>;
};

const AutomatedQuotesWorkspace = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const {id} = useParams<{ [id: string]: string }>();
  const [tabValue, setTabValue] = useState('listings');

  const {
    quoteGroupsAttributeData,
    quoteProductsByGroup,
    quoteProducts,
    quoteGroupsLoading,
    quoteProductsLoading,
    loadingQuoteProductSubscriptionOptions,
    allQuoteProducts
  } = useSelector((state: IReduxState) => state.quote);
  const { autoQuotes, autoQuotesLoading } = useSelector((state: IReduxState) => state.automatedQuotes);

  const loading = quoteProductsLoading || quoteGroupsLoading || loadingQuoteProductSubscriptionOptions || autoQuotesLoading;

  useEffect(() => {
    if (!quoteGroupsAttributeData.options.length) {
      getQuoteProGroupsAttributeApi({ dispatch });
    }

    if (!allQuoteProducts.length) {
      getQuoteProProductsApi({dispatch});
    }

    if (!Object.keys(quoteProductsByGroup).length || !quoteProducts.length) {
      getQuoteProProductsBySearchCriteriaApi({
        dispatch,
        sortDirection: 'asc',
        sortField: 'name',
        pageSize: '',
        currentPage: '',
        filterConditions: [
          {
            field: 'status',
            value: '1',
            conditionType: 'eq'
          },
        ],
        searchConditions: []
      });
    }

    if (!autoQuotes.length) {
      getAutoQuotesApi({ dispatch });
    }
  }, [dispatch, id]);

  const handleCancel = () => {
    history.push(`/automated-quotes/${id}/customer-preview`);
  };

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Automated Quotes', path: '/automated-quotes'},
            { name: 'Customer Preview', path: `/automated-quotes/${id}/customer-preview`},
            { name: 'Quote Workspace' }
          ]}
        />
      </div>
      <Card className="mx-10 p-8 root-card">
        <Grid container alignItems="center" justifyContent="center">
          <Tabs
            value={tabValue}
            onChange={(event, newValue) => setTabValue(newValue)}
            variant="scrollable"
            scrollButtons="auto"
            style={{minHeight: '40px', height: '40px'}}
            classes={{
              indicator: classes.tabIndicator,
              flexContainer: classes.fullWidthTabs,
            }}
          >
            <Tab
              label="Listings"
              value="listings"
              className={
                tabValue === 'listings' ? classes.activeTab : classes.inactiveTab
              }
            />
            <Tab
              label={<span className="whitespace-no-wrap">Packages</span>}
              value="packages_treatments_plans"
              className={
                tabValue === 'packages_treatments_plans'
                  ? classes.activeTab
                  : classes.inactiveTab
              }
            />
          </Tabs>
        </Grid>
        <Grid container spacing={2} alignItems="center" className="mt-2">
          <Grid item xs={12}>
            <TabPanel value={tabValue} index="listings">
              <AutomatedQuotesListings handleCancel={handleCancel} />
            </TabPanel>

            <TabPanel value={tabValue} index="packages_treatments_plans">
              <AutomatedQuotesPackages handleCancel={handleCancel} />
            </TabPanel>
          </Grid>
        </Grid>
      </Card>
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default AutomatedQuotesWorkspace;
